{
  "en": {
    "collections": {
      "headings": {
        "courses": "Suitable Courses",
        "gradeLevels": "Grade Levels",
        "materials": "Materials",
        "schoolTypes": "School types",
        "subjectTypes": "Subject types"
      },
      "howTo": {
        "header": {
          "heading": "The Collections - discover ready-made teaching materials",
          "link": "Discover all collections",
          "list_html": "<li><i class='bi bi-check-lg'></i>Collections are curated collections of educational resources on specific topics and for specific target groups.</li><li><i class='bi bi-check-lg'></i>Find complete lesson plans with complete materials, or pick individual elements and adapt them to your needs.</li><li><i class='bi bi-check-lg'></i>With the remix button, you can create your own copy in your own clipboard in no time at all and use it directly in your own lesson.</li>"
        },
        "recommendations": {
          "heading": "Discover current collections"
        },
        "tile": {
          "collectionTitle": "Substitution lessons with learning in motion",
          "help": {
            "author_partner": "Author or partner",
            "title": "Collection topic"
          },
          "staticAlt": "Kids playing ball in nature"
        },
        "title": "Everything you need to know about collections"
      },
      "labels": {
        "fobizzTeam": "The fobizz team"
      },
      "links": {
        "breadCrumbIndex": "Gallery",
        "email": "E-Mail",
        "learnMore": "Learn more"
      },
      "modelName": "Collection",
      "correctionAssistantHint": "AI can support teachers in analyzing student work and formulating feedback. The generated content consists of suggestions that must always be reviewed. Pedagogical evaluation is always carried out by the teacher. More information can be found <a href='https://app.fobizz.com/website/public_pages/63f40923-707c-4c29-a3fb-24190cbaccd4?public_token=5661a251e6152bb6cc51ff14facde3d4&back_url=https%3A%2F%2Fapp.fobizz.com%2Fcollections%2Fb7294bbe-a1df-4a10-9031-89fc64cd1766&back_title=Vorlagen%20f%C3%BCr%20Korrekturhilfe%20und%20SuS-Feedback%20Assistenten' target='_blank'>here</a>.",
      "searchPlaceholder": "Search materials",
      "share": {
        "email": {
          "body": "In the fobizz gallery I found \"{name}\" and I would like to share it with you. You can access it using this link: {shareUrl}"
        }
      }
    }
  }
}
